<template>
    <div class="container pt-3">
        <img :src="logo" height="50" class="mt-5">
        <div class="gv-container-header d-flex flex-column align-items-center pt-5 justify-content-center text-center">
            <h1 class="display-1 text-muted"><strong>401</strong></h1>
            <h2 class="title"><strong>No se encontró ninguna autorización</strong></h2>
            <p class="text-muted mb-0">Esta página no está disponible públicamente.</p>
            <p class="text-muted">Para acceder por favor inicie sesión primero</p>
            <router-link :to="{ name: 'Login' }" class="btn btn-h btn-dark">Iniciar sessión</router-link>
        </div>
    </div>
</template>
<script>
import logo from '@/assets/img/logo.png'
export default {
    data(){
        return {
            logo
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/P401.vue